// Height (px) for a chat window so its composer sits inside the viewport without scrolling the page.
// Keep import-free: cypress/node-tests/conversations-composer-fits-viewport.test.js executes this file.
//
// viewportHeight: window.innerHeight
// pageTop:        the chat's top edge in PAGE coordinates (getBoundingClientRect().top + scroll offset),
//                 so the result is the same whether or not the page is currently scrolled
// bottomGap:      breathing room left under the chat
// minHeight:      below this the chat is too cramped to be worth fitting on screen
// fallbackOffset: when it CAN'T fit (phones, short windows under banners) the page scrolls anyway, so
//                 keep the previous tall 'calc(100vh - 220px)' sizing instead of shrinking the thread
export function chatFitHeight(viewportHeight, pageTop, bottomGap = 16, minHeight = 420, fallbackOffset = 220) {
  const vh = Number(viewportHeight);
  const top = Number(pageTop);
  if (!Number.isFinite(vh) || !Number.isFinite(top)) return minHeight;
  const fit = Math.floor(vh - top - bottomGap);
  if (fit >= minHeight) return fit;
  return Math.max(minHeight, Math.floor(vh - fallbackOffset));
}
